import { CouponType } from 'types/coupon'
import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { convertCouponCode } from 'reducks/coupon/operations'
import { db, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'

const registerCoupon = (coupon: CouponType, couponCodes: string[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    if (coupon.code !== '') {
      // クーポンコードを大文字にする
      coupon.code = coupon.code.toUpperCase()
    } else {
      // クーポンコードが未入力であれば自動生成
      coupon.code = await convertCouponCode(couponCodes)
    }
    const now = FirebaseTimestamp.now()
    coupon.created_at = now
    coupon.updated_at = now
    const ref = db.collection('coupons').doc()
    return ref
      .set(coupon)
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(push(`/admin/coupon/create/complete?id=${ref.id}`))
      })
      .catch((error) => {
        console.error(error)
      })
  }
}

export default registerCoupon
